import Master from 'assets/master-inactive-icon.svg';
import Bachelor from 'assets/bachelor-inactive-icon.svg';
import N_1 from 'assets/N-1.svg';
import N_2 from 'assets/N-2.svg';
import N_3 from 'assets/N-3.svg';
import N_4 from 'assets/N-4.svg';
import N_5 from 'assets/N-5.svg';
import N_6 from 'assets/N-6.svg';
import N_7 from 'assets/N-7.svg';
import N_8 from 'assets/N-8.svg';
import N_9 from 'assets/N-9.svg';

interface Props {
  type: 'bachelor' | 'master' | number;
  active?: boolean;
  header?: boolean;
}

export default function SemesterIcon(props: Props) {
  let icon;
  switch (props.type) {
    case 1:
      icon = N_1;
      break;
    case 2:
      icon = N_2;
      break;
    case 3:
      icon = N_3;
      break;
    case 4:
      icon = N_4;
      break;
    case 5:
      icon = N_5;
      break;
    case 6:
      icon = N_6;
      break;
    case 7:
      icon = N_7;
      break;
    case 8:
      icon = N_8;
      break;
    case 9:
      icon = N_9;
      break;
    case 'bachelor':
      icon = Bachelor;
      break;
    case 'master':
      icon = Master;
      break;
    default:
      icon = null;
  }
  return (
    <img
      className="articleModal__body__usergroup__accordion__icon"
      src={icon}
      alt="no logo"
      style={{
        filter: props.active
          ? 'invert(54%) sepia(70%) saturate(2412%) hue-rotate(9deg) brightness(104%) contrast(105%)'
          : 'none',
        width: props.header ? '24px' : '16px',
        margin: props.header ? '0 12px' : undefined
      }}
    />
  );
}
